const ScenarioOptions = [
    { value: 'Max_Profit', label: "Maximization Of Profit" },
    { value: 'Max_Efficiency', label: "Maximization Of Efficiency" },
    { value: 'Max_Draw', label: "Maximization Of Draw" },
    { value: 'Max_SKU', label: "Maximization of Customers/SKU" }
  ];

  export { ScenarioOptions }